import { useMutation } from '@tanstack/react-query';

import { omniValidateCluster } from '@api/sdk.gen';
import { OmniValidateClusterPayload } from '@api/types.gen';

import { withError } from '@/react-tools/react-query';

export function useValidateOmniCluster() {
  return useMutation({
    mutationFn: ({
      payload,
      credentialID,
    }: {
      payload: OmniValidateClusterPayload;
      credentialID: number;
    }) =>
      omniValidateCluster({
        path: { credentialID },
        body: payload,
      }),
    ...withError('Cluster configuration validation failed'),
  });
}
